import type { PensionAsset } from "~/types/assets.types";
import { calculatePensionYears } from "./years";

export const calculatePensionYearlyYield = (userProduct: PensionAsset) => {
  const balance = userProduct?.amount || 0;
  const initialBalance = userProduct?.initialFundSum || 0;
  const years = calculatePensionYears(userProduct);

  if (userProduct.expectedYield) return userProduct.expectedYield;

  if (
    Number(balance) === 0 ||
    Number(initialBalance) === 0 ||
    Number(years) === 0
  )
    return 0;
  return (balance - initialBalance) / initialBalance / years;
};
